export default "__VITE_ASSET__DseyZtDq__"